import Notifications from 'react-notification-system-redux';
import { api } from '../../../general/apiScenarios';
import { CHNode, INodeToCHNode } from '../../../general/node';
import { ListenerApiLight, _select, lm } from '../../listenerMiddleware';
import { AutoConflictResolution } from '../conflictResolver/model';
import { resolve } from '../conflictResolver/sagas';
import { TrashActions } from './reducer';
import { getPage } from '../app/selectors';
import { Page } from '../../models/page';
import * as fileManagerActions from '../fileManager/actions';
export function TrashRootListener() {
  watchUpdateRequest();
  watchPutBack();
}

async function updateList(lapi: ListenerApiLight) {
  lapi.dispatch(TrashActions.update({ nodes: [], loading: true }));
  const trash = await api.trash.load();
  if (lapi.signal.aborted) return;
  if (trash.success) {
    // Filter out nodes where user doesn't have write permission to restore to original location
    const accessibleNodes = trash.data.response.nodes
      .filter((node) => node.perms?.includes('write') ?? false)
      .map(INodeToCHNode);
    lapi.dispatch(TrashActions.update({ nodes: accessibleNodes, loading: false }));
  } else {
    lapi.dispatch(TrashActions.update({ nodes: [], loading: false }));
  }
}

function watchUpdateRequest() {
  lm.takeLatest(TrashActions.updateRequested, async (_, lapi) => {
    await updateList(lapi);
  });
}

async function restoreOne(lapi: ListenerApiLight, node: CHNode) {
  function success() {
    lapi.dispatch(
      Notifications.success({
        title: `${node.name} recovered`,
      }),
    );
    lapi.dispatch(fileManagerActions.nodeRemoved({ node }));
  }

  const result = await api.trash.recovery(node.id, false);
  lapi.signal.throwIfAborted();

  if (result.success === false) {
    const errorStatus = result.errorData?.status;
    const data = result.errorData?.response?.data;

    // Handle 400 conflict errors (file already exists at target location)
    if (
      errorStatus === 400 &&
      typeof data === 'object' &&
      'message' in data &&
      data.message.includes('already exists')
    ) {
      const autoResolution = await resolve(lapi, node.name);
      lapi.signal.throwIfAborted();
      if (autoResolution === AutoConflictResolution.Overwrite) {
        const result2 = await api.trash.recovery(node.id, true);
        lapi.signal.throwIfAborted();
        if (result2.success) {
          success();
        } else {
          // Handle error from overwrite attempt
          const errorData = result2.errorData?.response?.data;
          lapi.dispatch(
            Notifications.error({
              title: 'Failed to recover file',
              message: typeof errorData === 'string' ? errorData : JSON.stringify(errorData),
            }),
          );
        }
      }
    } else {
      // Handle all other errors (permission denied, not found, server errors, etc.)
      const errorMessage = typeof data === 'string' ? data : data?.message ?? JSON.stringify(data);
      lapi.dispatch(
        Notifications.error({
          title: 'Failed to recover file',
          message: errorMessage,
        }),
      );
    }
  } else if (result.success) {
    success();
  }
}

function watchPutBack() {
  lm.takeLatest(TrashActions.putBackRequested, async (action, lapi) => {
    const page = _select(lapi, getPage);
    if (page === null) return;
    for (const node of action.payload.nodes) {
      await restoreOne(lapi, node);
      lapi.signal.throwIfAborted();
    }
    if (page === Page.TRASH) {
      // eslint-disable-next-line @myua/rtk-helper/check-signal-aborted
      await updateList(lapi);
    }
  });
}
